import { useContext } from 'react';
import { CopilotChannelContext } from '../channel/CopilotChannelContext';
export const useCopilotFreeContext = () => {
  const {
    channelState
  } = useContext(CopilotChannelContext);
  return channelState.freeContext;
};